import React from 'react'
import {Icon} from '@chakra-ui/react'

const CheckIconCircle = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" data-testid="check-icon" {...props}>
            <g clipPath="url(#clip0_131_18682)">
                <path
                    d="M8 0.583008C12.0958 0.583184 15.4158 3.90417 15.416 8C15.4158 12.0959 12.0959 15.4158 8 15.416C3.90417 15.4158 0.583184 12.0958 0.583008 8C0.583206 3.90418 3.90418 0.583206 8 0.583008ZM10.5303 6.13672C10.2374 5.84383 9.76262 5.84383 9.46973 6.13672L7.33301 8.27246L6.53027 7.46973C6.23742 7.17705 5.76258 7.17705 5.46973 7.46973C5.17707 7.76258 5.17706 8.23743 5.46973 8.53027L6.80273 9.86426C7.09547 10.1568 7.57041 10.1566 7.86328 9.86426L10.5303 7.19727C10.8231 6.90443 10.823 6.42963 10.5303 6.13672Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_131_18682">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default CheckIconCircle
